import { GET_ALL_SUBORDER } from 'src/apiService/apiDeclaration';
import usePagination from 'src/hooks/usePagination';
import SecondaryTable from './SecondaryTable';
import { operatorDashboardColumns } from 'src/constants';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const OperatorSubOrderSection = ({ status = '', title, date = '' }) => {
  const navigate = useNavigate();
  const { loading, data } = usePagination(GET_ALL_SUBORDER, {
    status: status,
    date: date,
    page: 1,
    pageSize: 5,
  });
  const handleNavigate = () => {
    navigate('/sub-order', { state: status });
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h4">{title}</Typography>
      </div>
      <SecondaryTable data={data && data} columns={operatorDashboardColumns} loading={loading} />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', pb: 2 }}>
        <Button disabled={data.rowCount === 0} onClick={handleNavigate}>
          {t('dashboard.viewMore')}
        </Button>
      </div>
    </>
  );
};

export default OperatorSubOrderSection;
